import { render, staticRenderFns } from "./ipLocation.vue?vue&type=template&id=e8dfd2c6&"
import script from "./ipLocation.vue?vue&type=script&lang=js&"
export * from "./ipLocation.vue?vue&type=script&lang=js&"
import style0 from "./ipLocation.vue?vue&type=style&index=0&id=e8dfd2c6&prod&lang=less&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports